<div class="site-menu">
	<div class="cont">
		<div>
			@if (!isOwner) {
				<div class="main-menu">
					@for (item of menuService.menu; track item) {
						<div
							(mouseenter)="item.isOpen = true"
							(mouseleave)="item.isOpen = false"
							[class.active]="
								curMenuItem == item?.id || curMenuItem == item?.link
							"
						>
							<app-icon
								pointer
								(click)="menuItemClick(item)"
								[icon]="item.icon"
								[isImg]="item.isImg"
								[titleLang]="item.lang"
							/>

							@if (item.children && item.isOpen) {
								<div
									class="menu-float"
									[class.menu-float-home]="item?.id == 'home'"
								>
									@for (subItem of item.children; track subItem) {
										@if (!subItem.hidden && !subItem.hiddenCc) {
											<div (click)="menuItemClick(subItem)">
												<div>
													<app-icon
														[icon]="subItem.icon"
														[isImg]="subItem.isImg"
														[titleLang]="subItem.lang"
													/>
												</div>
												<div>{{ subItem.lang | langVal }}</div>
											</div>
										}
									}
								</div>
							}
						</div>
					}
					<div
						class="notif-icon"
						(click)="modalProps = { name: 'task' }"
					>
						<app-icon
							icon="notifications"
							isImg="true"
							titleLang="notifications"
						/>
						@if (store.unreadTasks) {
							<div class="badge">
								{{ store.unreadTasks !== null ? store.unreadTasks : "" }}
							</div>
						}
					</div>
				</div>
			}
		</div>

		<div class="d-flex gap-3 mx-3 flex-nowrap">
			<div class="searchBar">
				@if (!eventsService.isXs || isPatientSearchOpen) {
					<div class="comp">
						<app-gen-autocomplete
							#searchFuzzy
							title_ph_lang="patients_plus"
							[fuzzySearchableClasses]="
								permsService?.perms?.administrative
									? ['patients', 'contacts', 'payors']
									: ['patients', 'contacts']
							"
							(chosenEvent)="fuzzyClick($event)"
							[searchableFields]="['name', 'id_number']"
							optionDisplay="%name% %id_number%"
						/>
					</div>
				}
				@if (eventsService.isXs && !isPatientSearchOpen) {
					<div
						class="icon search"
						(click)="handlePatientSearchIconClick($event)"
					>
						<app-icon icon="search" />
					</div>
				}
			</div>

			@if (!isOwner && showSearchByPhone == "yes") {
				<div class="searchBar">
					@if (!eventsService.isXs || isContactwaySearchOpen) {
						<div class="comp">
							<app-menu-contactway-search />
						</div>
					}
					@if (eventsService.isXs && !isContactwaySearchOpen) {
						<div
							class="icon"
							(click)="handleContactwaySearchIconClick($event)"
						>
							<app-icon icon="mobile" />
						</div>
					}
				</div>
			}
			@if (
				permsService?.perms?.administrative ||
				permsService?.perms?.add_new_patient
			) {
				<button
					class="btn btn-icon open-patient-form"
					(click)="modalProps = { name: 'types-create' }"
					titleLang="add"
					icon="insert-circle"
					isImg
				></button>
			}
		</div>

		<div class="user-menu">
			<backup-btn />

			<div class="d-none d-lg-block">
				<div
					(click)="userMenuOpen($event)"
					titleLang="user"
					class="pointer"
					postIcon="caret-down"
				>
					{{ cliniqData?.user_name }}
				</div>

				@if (userMenuIsOpen) {
					<div class="menu-float">
						<div
							routerLink="/user"
							titleLang="my_account"
						>
							<div icon="setting1"></div>
							<span>{{ "my_account" | langVal }}</span>
						</div>
						<div
							[routerLink]="
								permsService?.owner_has_users && !isOwner
									? 'sub-user-config-cliniq'
									: 'config-cliniq'
							"
							titleLang="configuration"
						>
							<div icon="setting2"></div>
							<div>{{ "configuration" | langVal }}</div>
						</div>

						@if (
							permsService?.perms?.administrative &&
							!["free", "intern"].includes(cliniqData.status)
						) {
							<div
								routerLink="/purchases/create"
								titleLang="payment"
							>
								<div icon="invoice"></div>
								<div>{{ "payment" | langVal }}</div>
							</div>
							<div
								titleLang="get_2fa_key"
								(click)="modalProps = { name: 'google2fa-qr-code' }"
							>
								<div icon="authenticate"></div>
								<div>{{ "get_2fa_key" | langVal }}</div>
							</div>
							<div
								titleLang="affiliate_link"
								(click)="openAffiliateLink()"
							>
								<div icon="affiliate"></div>
								<div>{{ "affiliate_link" | langVal }}</div>
							</div>
							<div
								titleLang="create_takbull_account"
								(click)="modalProps = { name: 'create-takbull-account' }"
							>
								<div icon="takbull"></div>
								<div>{{ "create_takbull_account" | langVal }}</div>
							</div>
							<div
								titleLang="create_grow_account"
								(click)="modalProps = { name: 'create-grow-account' }"
							>
								<div
									icon="grow"
									isImg="true"
								></div>
								<div>{{ "create_grow_account" | langVal }}</div>
							</div>
							@if (enable_israel_invoice) {
								<div
									titleLang="ita_get_auth"
									(click)="modalProps = { name: 'ita-get-auth' }"
								>
									<div icon="info"></div>
									<div>{{ "ita_get_auth" | langVal }}</div>
								</div>
							}
							@if (permsService?.owner_has_users) {
								<div
									titleLang="invite_partner"
									(click)="modalProps = { name: 'invite-partner' }"
								>
									<div icon="takbull"></div>
									<div>{{ "invite_partner" | langVal }}</div>
								</div>
							}
						}
						<!-- @if(!permsService?.owner_has_users){
              <div titleLang="time_allocation" routerLink="/time-allocation">
                <div icon="calendar1"></div>
                <div>{{"time_allocation" | langVal}}</div>
              </div>
            } -->

						<div
							titleLang="change_password"
							(click)="modalProps = { name: 'change-password' }"
						>
							<div icon="changePassword"></div>
							<div>{{ "change_password" | langVal }}</div>
						</div>
						<!--						<div-->
						<!--							titleLang="walkthrough"-->
						<!--							(click)="modalOpen='walkthrough'"-->
						<!--						>-->
						<!--							<div icon="changePassword"></div>-->
						<!--							<div>{{ "walkthrough" | langVal }}</div>-->
						<!--						</div>-->
					</div>
				}
			</div>

			<div
				(click)="logout()"
				titleLang="logout"
				icon="logout"
				class="pointer"
			></div>
			<!--[routerLink]="'config-cliniq'" -->
			<div
				[routerLink]="isOwner ? 'config-cliniq' : '/'"
				title="My-cliniq"
				class="pointer"
			>
				<img
					src="assets/images/main-logo.svg"
					class="LOGO"
				/>
			</div>
		</div>
	</div>
</div>

@switch (modalProps?.name) {
	@case ("reports") {
		<app-reports
			isModalMode
			[report_name]="modalProps.report_name"
			(onClose)="modalProps = null"
		/>
	}
	@case ("profitloss") {
		<app-profitloss
			isModalMode
			(onClose)="modalProps = null"
		/>
	}
	@case ("types-create") {
		<app-types-create (onClose)="modalProps = null" />
	}
	@case ("taxes-report") {
		<app-taxes-report
			isModalMode
			(onClose)="modalProps = null"
		/>
	}
	@case ("walkthrough") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="walkthrough"
		>
			<app-walkthrough (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("sign-documents") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="documents"
		>
			<app-sign-documents (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("data-export") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-narrow-width"
			title="export"
		>
			<app-data-export (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("create-takbull-account") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-small-width"
			title="create_takbull_account"
		>
			<app-create-takbull-account (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("create-grow-account") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-small-width"
			title="create_grow_account"
		>
			<app-create-grow-account (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("graphs-data") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="graphs"
		>
			<app-graphs-data (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("change-password") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="change_password"
			modalWrapperClass="modal-narrow-width"
		>
			<app-change-password
				(onClose)="modalProps = null"
				isModalMode
			/>
		</app-modal-wrap>
	}
	@case ("bkmvdata-report") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="irs"
		>
			<app-bkmvdata-report (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("sub-user-payments") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="sub_user_payments"
		>
			<app-sub-user-payments (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("google2fa-qr-code") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			hasExit
			title="get_2fa_key"
			modalWrapperClass="modal-default-width"
		>
			<app-google2fa-qr-code (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("meeting-times") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="meeting_times"
			modalWrapperClass="modal-800"
		>
			<app-meeting-times (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("meeting-times") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="meeting_times"
			modalWrapperClass="modal-800"
		>
			<app-meeting-times (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("sub-user-patients") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="patients"
		>
			<app-sub-user-patients
				(onClose)="modalProps = null"
				isModalMode
			/>
		</app-modal-wrap>
	}
	@case ("invite-partner") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="invite_partner"
			modalWrapperClass="modal-small-width"
		>
			<app-invite-partner (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("followups-for-supervisor-list") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="followups"
		>
			<app-followups-for-supervisor-list (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("ita-get-auth") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="ita_get_auth"
			modalWrapperClass="modal-650"
		>
			<app-ita-get-auth (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("copy-link") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-small-width"
			title="affiliate_header"
		>
			<app-copy-link
				(onClose)="modalProps = null"
				[link]="modalProps.link"
			/>
		</app-modal-wrap>
	}
	@case ("task") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-650"
			title="tasks"
		>
			<app-task
				(onClose)="modalProps = null"
				[taskId]="modalProps.taskId"
			/>
		</app-modal-wrap>
	}
	@case ("error") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-650"
			title="how_can_we_help"
		>
			<app-error (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
}
